module.exports = __webpack_public_path__ + "img/fast-time.c9255a00.png";